import React from "react";
import { Link } from "react-router-dom";
import {
	Calculator,
	BookOpen,
	FlaskConical,
	Leaf,
	Book,
	BarChart2,
} from "lucide-react";

// import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { createSlug } from "../../config/utils.js";
import { Card, CardHeader, CardContent } from "../../components/ui/card.jsx";

const SubjectsData = [
	{
		name: "Math",
		icon: <Calculator className="text-red-600 w-10 h-10" />,
		subSubjects: [
			"Algebra",
			"Graphs & Coordinate Geometry",
			"Numbers & Numeration",
			"Calculus",
			"Geometry",
			"Trigonometry",
		],
	},
	{
		name: "Biology",
		icon: <Leaf className="text-green-600 w-10 h-10" />,
		subSubjects: [
			"Plant Biology",
			"Animal Biology",
			"Cell Biology",
			"Physiology & Homeostasis",
		],
	},
	{
		name: "Chemistry",
		icon: <FlaskConical className="text-sky-500 w-10 h-10" />,
		subSubjects: [
			"Fundamentals of Chemistry",
			"States of Matter & Properties",
			"Chemical Bonding & Molecular Structure",
			"Chemical Reactions & Stoichiometry",
			"Solutions & Separation Techniques",
			"Particle Motion & Diffusion",
		],
	},
	{
		name: "Literature",
		icon: <Book className="text-pink-600 w-10 h-10" />,
		subSubjects: [
			"African Poetry",
			"Non-African Poetry",
			"African Drama",
			"Non-African Drama",
			"African Prose",
			"Non-African Prose",
			"Shakespearean Texts",
		],
	},
	{
		name: "Commerce",
		icon: <BarChart2 className="text-orange-600 w-10 h-10" />,
		subSubjects: [
			"Introduction to Commerce & Business",
			"Business Structures & Organizations",
			"Trade & Markets", 
			"Financial Aspects of Business",
			"Industry & Production",
			"Trade & Consumer Protection",
		],
	},
	{
		name: "English",
		icon: <BookOpen className="text-purple-600 w-10 h-10" />,
		subSubjects: [
			"Grammar & Sentence Structure",
			"Parts of Speech",
			"Figures of Speech & Literary Devices",
			"Idioms & Vocabulary",
			"Phonetics & Pronunciation",
			"Punctuation",
			"Reading & Comprehension",
		],
	},
];

export const SubjectsDataWithSlugs = SubjectsData.map((subject) => ({
	...subject,
	slug: createSlug(subject.name),
	subSubjects: subject.subSubjects.map((subSubject) => ({
		name: subSubject,
		slug: createSlug(subSubject),
	})),
}));

export default function SubjectsSection() {
	return (
		<section id="courses" className="px-4 py-12 bg-white text-gray-900">
			<div className="max-w-6xl mx-auto text-center mb-10">
				<h2 className="text-3xl md:text-4xl font-bold mb-4">
					Lessons Revolve Around 6 Areas!
				</h2>
				<p className="text-lg text-gray-600">
					Engaging lessons across subjects like Math, Biology,
					Chemistry, and more—with new topics and content added
					regularly.
				</p>
			</div>

			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
				{SubjectsDataWithSlugs.map((subject) => (
					<Card
						key={subject.name}
						className="hover:shadow-md transition">
						<CardHeader className="flex flex-col items-center gap-2">
							{subject.icon}
							<h3 className="text-xl font-semibold">
								{subject.name}
							</h3>
						</CardHeader>
						<CardContent>
							<ul className="space-y-1">
								{subject.subSubjects.map((subSubject) => (
									<li key={subSubject.slug}>
										<Link
											to={`/courses/${subject.slug}/${subSubject.slug}`}
											className="text-blue-600 text-sm hover:underline">
											{subSubject.name}
										</Link>
									</li>
								))}
							</ul>
						</CardContent>
					</Card>
				))}
			</div>
		</section>
	);
}
